import React from 'react';
import { motion } from 'framer-motion'; 
import ProjectStatsBadge from '../../../components/ProjectStatsBadge';
import ShareProjectButton from '../../../components/ShareProjectButton/ShareProjectButton';
import './easy-hub.css'; 
import easyHubImage from '../../../assets/images/easyhub.png'; 

const EasyHub = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        Easy <span>Hub</span>
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        <br />
        Last Updated On: 12th July 2026
      </motion.p>

      <div className="project-content">
        <motion.div 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={easyHubImage} alt="Easy Hub" className="project-image" />
          <h2 className="project-subtitle">Easy Hub</h2>
          <span className="project-category">Web Development</span>
          <p className="project-author">Author: Praveen Kumar B</p>

          <ProjectStatsBadge docId="easyHub" trackView={true} />

          {/* Buttons */}
          <div className="project-buttons">
            <a href="https://easy-hub.netlify.app/" className="visit-project-button">
              → Visit the Project
            </a>
            <a href="https://github.com/Praveenkumar-king/Easy-hub" className="visit-project-button">
              → View on GitHub
            </a>
            <ShareProjectButton
              project={{
                id: "easyHub",
                title: "Easy Hub",
                path: "/projects/projectdetail/easy-hub"
              }}
            />
          </div>
        </motion.div>

        <motion.div 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">Project Details</h3>
          <p className="overview-text">
            Welcome to the <strong>Easy Hub</strong>! Here's a detailed overview of the modern e-commerce platform and its features.
          </p>

          <h3 className="section-title">Overview 🌟</h3>
          <p className="overview-description">
            The <strong>Easy Hub</strong> is a modern and responsive e-commerce website designed to provide a seamless online shopping experience. Users can browse products, explore categories, add items to their cart, and enjoy a clean and intuitive interface across all devices.
          </p>

          <h3 className="section-title">Key Features 🛠️</h3>
          <ul className="feature-list">
            <li><strong>Product Catalog</strong> 🛍️ - Browse a wide range of products with attractive product cards.</li>
            <li><strong>Shopping Cart</strong> 🛒 - Add, update, and remove products with ease.</li>
            <li><strong>Category Browsing</strong> 📦 - Explore products through organized categories.</li>
            <li><strong>Responsive Design</strong> 📱 - Optimized for desktop, tablet, and mobile devices.</li>
          </ul>

          <h3 className="section-title">How the Website Works 🔍</h3>
          <ul className="how-it-works-list">
            <li><strong>Browse Products</strong> 🛍️ - Explore products from different categories.</li>
            <li><strong>Select Items</strong> ➕ - Add your favorite products to the shopping cart.</li>
            <li><strong>Review Cart</strong> 🛒 - Update quantities or remove products before checkout.</li>
            <li><strong>Checkout</strong> 💳 - Complete the shopping process through a user-friendly interface.</li>
          </ul>

          <h3 className="section-title">Features & Benefits 🚀</h3>
          <ul className="benefits-list">
            <li><strong>Modern UI</strong> 🎨 - Clean and attractive shopping interface.</li>
            <li><strong>Easy Navigation</strong> 🧭 - Quickly browse products and categories.</li>
            <li><strong>Responsive Experience</strong> 📱 - Smooth performance across all screen sizes.</li>
            <li><strong>Better Shopping Experience</strong> 🚀 - User-friendly design improves customer engagement.</li>
          </ul>

          <h3 className="section-title">Technical Details ⚙️</h3>
          <ul className="technical-details-list">
            <li><strong>Frontend</strong> 🖥️ - React.js, HTML5, CSS3, and JavaScript (ES6).</li>
            <li><strong>Animations</strong> ✨ - Framer Motion for smooth transitions.</li>
            <li><strong>Responsive Design</strong> 📱 - Built using CSS Flexbox, Grid, and Media Queries.</li>
            <li><strong>Deployment</strong> ☁️ - Hosted on Netlify with GitHub for version control.</li>
          </ul>

          <h3 className="section-title">Real-Life Applications 🌍</h3>
          <ul className="real-life-applications-list">
            <li><strong>Online Shopping</strong> 🛍️ - Buy products from anywhere.</li>
            <li><strong>Retail Stores</strong> 🏬 - Showcase products digitally.</li>
            <li><strong>Small Businesses</strong> 📦 - Sell products through an online platform.</li>
            <li><strong>E-Commerce Startups</strong> 🚀 - Build scalable online shopping solutions.</li>
          </ul>

          <h3 className="section-title">Future Features 🔮</h3>
          <ul className="future-features-list">
            <li><strong>User Authentication</strong> 🔐 - Secure login and account management.</li>
            <li><strong>Online Payments</strong> 💳 - Integrate secure payment gateways.</li>
            <li><strong>Wishlist</strong> ❤️ - Save favorite products for future purchases.</li>
            <li><strong>Order Tracking</strong> 📦 - Track orders in real time.</li>
          </ul>

          <h3 className="section-title">Conclusion 🎯</h3>
          <p>
            The <strong>Easy Hub</strong> is a responsive e-commerce platform that offers a smooth online shopping experience with product browsing, category management, shopping cart functionality, and a modern user interface. This project showcases responsive web design and modern front-end development skills.
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default EasyHub;